module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.data) ? _c('div', {
    staticClass: "col-sm-12 col-md-9",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('img', {
    staticClass: "background",
    attrs: {
      "src": _vm.assignmentImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 course-description",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.$route.name !== 'campus-dashboard') ? _c('div', [(_vm.$route.name != 'videoPlayer') ? _c('h4', [_c('router-link', {
    attrs: {
      "to": {
        name: 'videoPlayer',
        params: {
          courseId: _vm.data.courseId,
          instanceId: _vm.data.instanceId,
          videoId: _vm.data.videoId
        },
        query: {
          week: _vm.data.week,
          tab: 'assignment'
        }
      }
    }
  }, [_vm._v("\n                           Week " + _vm._s(_vm.data.week))]), _vm._v(", " + _vm._s(_vm.data.name) + "\n                   ")], 1) : _c('h4', [_vm._v("\n                       Week " + _vm._s(_vm.data.week) + ", " + _vm._s(_vm.data.name) + "\n                   ")])]) : _c('div', [_c('h4', [_vm._v(_vm._s(_vm.data.name))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [(_vm.data.image) ? _c('img', {
    staticClass: "assignment-image",
    attrs: {
      "src": _vm.assignmentImage
    },
    on: {
      "click": function($event) {
        _vm.showLightBox = true
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 assignment-sidebar"
  }, [(_vm.$route.name !== 'campus-dashboard') ? _c('div', [_c('h4', [_vm._v("Due Date:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('If the due date has passed, you may not get a mark or feedback unless you contact your supervisor.'),
      expression: "'If the due date has passed, you may not get a mark or feedback unless you contact your supervisor.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "due-date"
  }, [_vm._v(_vm._s(_vm._f("shortDate")(_vm.data.dueDate)))]), _vm._v(" "), (new Date(_vm.data.dueDate) > new Date()) ? _c('countdown', {
    attrs: {
      "date": _vm.data.dueDate
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Assignment Files:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find files here required or related to your assignment.'),
      expression: "'Find files here required or related to your assignment.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.data.files || (_vm.data.watermarkedFiles && _vm.data.watermarkedFiles.length > 0)) ? _c('ul', {
    staticClass: "student-submitted-files"
  }, [_vm._l((_vm.data.files), function(file) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, _vm.data.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
  }), _vm._v(" "), _vm._l((_vm.data.watermarkedFiles), function(file) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, _vm.data.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
  })], 2) : _c('span', {
    staticClass: "no-files"
  }, [_vm._v("No files for this assignment")]), _vm._v(" "), (_vm.showDAMSubmission) ? _c('div', {
    staticClass: "modal-overlay final-project-submission-modal"
  }, [_c('i', {
    staticClass: "close-modal fa fa-times",
    on: {
      "click": function($event) {
        _vm.showDAMSubmission = false
      }
    }
  }), _vm._v(" "), _c('dam-submission', {
    attrs: {
      "type": 'finalAssignment',
      "assignment": _vm.data
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'campus-dashboard') ? _c('div', [(_vm.data.isFinalProject === true) ? _c('div', {
    staticClass: "final-assignment-submission"
  }, [_c('h4', [_vm._v("Submissions:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('You can optionally add a submission to the gallery'),
      expression: "'You can optionally add a submission to the gallery'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    class: {
      'resubmit': _vm.data.submissions && _vm.data.submissions.length > 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDAMSubmission = true
      }
    }
  }, [(_vm.data.submissions && _vm.data.submissions.length > 0) ? _c('span', [_vm._v("Resubmit Final Project")]) : _c('span', [_vm._v("Submit Final Project")])]), _vm._v(" "), _c('p', {
    staticClass: "resubmission-instructions"
  }, [_vm._v("Please note you must submit your final project by the due date in order to receive marks and feedback. You have an optional one week extension after the due date to revise your work (for scholarships / promotion), but this will not receive marks or feedback.")]), _vm._v(" "), (_vm.data.submissions) ? _c('ul', {
    staticClass: "submitted-files"
  }, _vm._l((_vm.data.submissions), function(submission) {
    return _c('li', [_c('label', [_vm._v("Submitted " + _vm._s(_vm._f("longDate")(submission.createdAt)))]), _vm._v(" "), _c('ul', {
      staticClass: "files"
    }, _vm._l((submission.url), function(url) {
      return _c('li', [_c('a', {
        attrs: {
          "href": url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(url.split('/').pop()))])])
    })), _vm._v(" "), (submission.feedback && _vm.isLatestGrade(submission.feedback.createdAt)) ? _c('span', [_vm._v(_vm._s(submission.grade) + "%")]) : _vm._e(), _vm._v(" "), (submission.feedback) ? _c('img', {
      attrs: {
        "src": require("../../../../assets/img/play-button-small-green.png")
      },
      on: {
        "click": function($event) {
          _vm.playFeedback(submission.feedback.body)
        }
      }
    }) : _vm._e()])
  })) : _vm._e()]) : _c('div', [_c('h4', [_vm._v("Submit Assignment"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Drag your file(s) here to submit.'),
      expression: "'Drag your file(s) here to submit.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('dropzone', {
    ref: _vm.submissionRef,
    attrs: {
      "id": _vm.submissionRef,
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 50,
      "thumbnail-width": 50,
      "dropzone-options": _vm.dropzoneOptions
    }
  }), _vm._v(" "), (_vm.dueDateInPast(_vm.data.dueDate)) ? _c('p', {
    staticClass: "submission-explanation"
  }, [_vm._v("\n                       You can submit and resubmit assignments past their due date but don't expect feedback unless you've contacted your supervisor. Late submissions may be subjected to reduced marks.\n                   ")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Comments and Questions\n                       "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Any comments and questions you have about the assignment.'),
      expression: "'Any comments and questions you have about the assignment.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }],
    staticClass: "comments form-control",
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  }), _vm._v(" "), (
    (!_vm.data.submissions || _vm.data.submissions.length < 1) &&
    _vm.dueDateInFuture(_vm.data.dueDate)) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (
    (!_vm.data.submissions || _vm.data.submissions.length < 1) &&
    _vm.dueDateInPast(_vm.data.dueDate)) ? _c('button', {
    staticClass: "btn overdue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("Submit (Past Due)")]) : _vm._e(), _vm._v(" "), (
    (_vm.data.submissions && _vm.data.submissions.length > 0) &&
    _vm.dueDateInFuture(_vm.data.dueDate)) ? _c('button', {
    staticClass: "btn resubmit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("Resubmit")]) : _vm._e(), _vm._v(" "), (
    (_vm.data.submissions && _vm.data.submissions.length > 0) &&
    _vm.dueDateInPast(_vm.data.dueDate)) ? _c('button', {
    staticClass: "btn btn-success submitted",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("Submitted")]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Submitted Files:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Click submit below to upload your assignment files. Note you can resubmit at anytime to replace them. You may not receive feedback if the due date has passed.'),
      expression: "'Click submit below to upload your assignment files. Note you can resubmit at anytime to replace them. You may not receive feedback if the due date has passed.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.data.submissions) ? _c('ul', {
    staticClass: "submitted-files"
  }, _vm._l((_vm.data.submissions), function(submission) {
    return _c('li', [_vm._l((submission.url), function(url) {
      return _c('a', {
        attrs: {
          "href": url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(url.split('/').pop()))])
    }), _vm._v(" "), (submission.feedback && _vm.isLatestGrade(submission.feedback.createdAt)) ? _c('span', [_vm._v(_vm._s(submission.grade) + "%")]) : _vm._e(), _vm._v(" "), (submission.feedback) ? _c('img', {
      attrs: {
        "src": require("../../../../assets/img/play-button-small-green.png")
      },
      on: {
        "click": function($event) {
          _vm.playFeedback(submission.feedback.body)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "separator"
    }, [_vm._v("\n                               " + _vm._s(_vm._f("shortDate")(submission.createdAt)) + "\n                           ")])], 2)
  })) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.showLightBox) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": function($event) {
        _vm.showLightBox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.showLightBox = false
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.assignmentImage
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying === true),
      expression: "feedbackPlaying===true"
    }],
    staticClass: "feedback-lightbox",
    on: {
      "click": function($event) {
        _vm.stopFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('poly-video', {
    ref: "videoPlayer",
    attrs: {
      "vjsOptions": _vm.videoPlayerOptions,
      "sources": _vm.videoPlayerSources
    },
    on: {
      "error": _vm.onVideoPlayerError,
      "loadedsource": _vm.onVideoPlayerLoadedSource
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a679684!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/assignments-table/templates/Child.vue
// module id = 1994
// module chunks = 2